module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/plus-icon-3b5af0fee423ba36e982ab27a7aec76c.svg";